import type { AuthMethod } from "@coremonit/types";
import type { WizardData } from "../wizardStore";
import { OptionGrid, StepHeader, Field } from "./common";
import { Input } from "@coremonit/design-system";
import { ShieldCheck, Key, UserCog, Lock } from "lucide-react";

const OPTIONS: Array<{ value: AuthMethod; label: string; description: string }> = [
  { value: "certificates",    label: "Certificates",     description: "mTLS with issued client cert (recommended)." },
  { value: "tokens",          label: "API Tokens",       description: "Bearer token in the Authorization header." },
  { value: "service-account", label: "Service Account",  description: "Kubernetes/Cloud service account with RBAC." },
  { value: "secrets",         label: "Secret Reference", description: "Secret in your vault (KMS/HashiCorp Vault)." },
];

interface Props { data: WizardData; update: (p: Partial<WizardData>) => void }

export function Step5Auth({ data, update }: Props) {
  const iconFor = (v: AuthMethod) => v === "certificates" ? <ShieldCheck size={14} /> : v === "tokens" ? <Key size={14} /> : v === "service-account" ? <UserCog size={14} /> : <Lock size={14} />;
  return (
    <div>
      <StepHeader title="Authentication" description="How should CoreMonit authenticate against the service or its telemetry endpoint?" />
      <OptionGrid<AuthMethod>
        value={data.authMethod}
        onChange={(v) => update({ authMethod: v })}
        options={OPTIONS.map(o => ({ ...o, icon: iconFor(o.value) }))}
        cols={2}
      />
      <div style={{ marginTop: 20, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <Field label="Secret reference">
          <Input value={data.authSecretRef ?? ""} onChange={(v) => update({ authSecretRef: v })}
                 placeholder={data.authMethod === "tokens" ? "vault:secret/coremonit/tokens/svc" : data.authMethod === "certificates" ? "k8s:secret/coremonit-mtls" : "sa/coremonit-observer"} size="md" />
        </Field>
        {data.authMethod === "tokens" && (
          <Field label="Token (optional — for one-off test)">
            <Input value={data.authToken ?? ""} onChange={(v) => update({ authToken: v })} type="password" placeholder="•••••••••••" size="md" />
          </Field>
        )}
      </div>
    </div>
  );
}
